<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Imprimir Listagem de Clientes
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="nomeImpressao" class="col-form-label">Nomeie a sua Impressão</label>
                            <input type="text" class="form-control" [(ngModel)]="nomeImpressao" name="nomeImpressao" id="nomeImpressao" 
                                #nomeImpressaoModel="ngModel">
                            <p class="form-text text-muted" style="margin-bottom:0px;">Nomeie a sua impressão para identificá-la facilmente.</p>
                            <p class="form-text text-muted" style="margin-top:0px;">Ex: Clientes Ativos da Cidade de São Paulo.</p>                                                                             
                        </div>
                    </div>  
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info">
                                <i class="fas fa-info" aria-hidden="true"></i> A impressão irá considerar os mesmos filtros e ordenação aplicados na pesquisa atual dos clientes.
                            </div>
                        </div>
                    </div>                  
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="print()" id="btnPrintListagem">
                    Imprimir
                </button>              
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>